import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import InstallPrompt from "@/components/InstallPrompt";
import ProtectedRoute from "@/components/ProtectedRoute";
import SplashScreen from "@/components/SplashScreen";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import DealDetail from "@/pages/DealDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SubmitLink from "@/pages/SubmitLink";
import PaymentReturn from "@/pages/PaymentReturn";
import MyLinks from "@/pages/MyLinks";
import Advertise from "@/pages/Advertise";
import BuyPlatform from "@/pages/BuyPlatform";
import PlatformStore from "@/pages/PlatformStore";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <SplashScreen />
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/site/:slug" element={<PlatformStore />} />
              <Route path="/site/:slug/category/:catslug" element={<CategoryPage />} />
              <Route path="/deal/:id" element={<DealDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/buy-platform" element={<BuyPlatform />} />
              <Route path="/payment/return" element={<PaymentReturn />} />
              <Route path="/submit" element={<ProtectedRoute><SubmitLink /></ProtectedRoute>} />
              <Route path="/advertise" element={<ProtectedRoute><Advertise /></ProtectedRoute>} />
              <Route path="/my-links" element={<ProtectedRoute><MyLinks /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute ownerOnly><AdminDashboard /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
